import axios from 'axios';

const client = axios.create({
  baseURL: '/api',
  timeout: 5000,
});

async function getNewProvider() {
  const response = await client.get('/events/locarius');
  return response.data;
}

const API = {
  getNewProvider,
};

export default API;